<div class="card-wrapper  d-flex flex-column gap-sm-4 gap-4 align-items-center"
    [ngClass]="{'confirmation-dialog-width':isConfirmWithdrawalStep && !withdrawalStatus}">
    <ng-container *ngIf="!withdrawalStatus; else hasWithdrawalStatus">
        <!-- CONTENTS BEFORE API CALL -->
        <div class="title-wrapper  d-flex flex-column gap-sm-4 gap-4 align-items-center w-100">
            <div class="top-header d-flex flex-column align-items-center w-100">
                <img src="assets/images/svg-icons/x-close.svg" alt="close" srcset="" class="close-img"
                    (click)="close()">
                <span class="title">{{ (isConfirmWithdrawalStep ? "confirm_withdrawal" : 'wallet_address') |
                    translate}}</span>
            </div>
            <span class="description">{{isConfirmWithdrawalStep ? ('confirm_withdrawal_info' | translate):
                ('wallet_address_info'|translate:{selectedChain: selectedChain})}}

            </span>
        </div>
        <!-- WALLET ADDRESS COLLECTION FORM -->
        <form *ngIf="!isConfirmWithdrawalStep; else confirmWithdrawal" [formGroup]="walletAddressForm"
            class="w-100 wallet-address d-flex flex-column gap-sm-4 gap-4" (ngSubmit)="submitAddress()">
            <div class="wallet-address-field d-flex flex-column gap-sm-1 gap-1">
                <label class="title-text" for="" translate>wallet_address</label>
                <div class="field-wrapper">
                    <input type="text" formControlName="walletAddress">
                    <img *ngIf="walletAddressForm.get('walletAddress')?.dirty"
                        [src]="walletAddressForm.get('walletAddress')?.errors ? './assets/images/svg-icons/red-cross.svg' : './assets/images/svg-icons/green-check.svg'"
                        class="validation-mark" alt="search-user" width="20" height="20">
                </div>
                <ng-container
                    *ngIf="walletAddressForm.get('walletAddress')?.touched && walletAddressForm.get('walletAddress')?.errors">
                    <span class="error-txt" *ngIf="walletAddressForm.get('walletAddress')?.hasError('required')"
                        translate>wallet_address_required</span>
                    <span class="error-txt"
                        *ngIf="walletAddressForm.get('walletAddress')?.hasError('pattern')">{{("non_compatible_wallet"|
                        translate:{selectedChain: selectedChain})}}</span>
                </ng-container>
            </div>
            <div class="wallet-address-field d-flex flex-column gap-sm-1 gap-1">
                <label for="" translate>confirm_wallet_address</label>
                <div class="field-wrapper">
                    <input type="text" formControlName="confirmWalletAddress">
                    <img *ngIf="walletAddressForm.get('confirmWalletAddress')?.dirty"
                        [src]="walletAddressForm.get('confirmWalletAddress')?.errors ? './assets/images/svg-icons/red-cross.svg' : './assets/images/svg-icons/green-check.svg'"
                        class="validation-mark" alt="search-user" width="20" height="20">
                </div>
                <ng-container
                    *ngIf="walletAddressForm.get('confirmWalletAddress')?.touched && walletAddressForm.get('confirmWalletAddress')?.errors">
                    <span class="error-txt" *ngIf="walletAddressForm.get('confirmWalletAddress')?.hasError('required')"
                        translate>confirm_address_required</span>
                    <span class="error-txt"
                        *ngIf="walletAddressForm.get('confirmWalletAddress')?.hasError('pattern')">{{("non_compatible_wallet"|
                        translate:{selectedChain: selectedChain})}}</span>
                    <span class="error-txt"
                        *ngIf="walletAddressForm.get('confirmWalletAddress')?.hasError('addressMismatch')"
                        translate>wallet_address_mismatch</span>
                </ng-container>
            </div>
            <button type="submit" class="action-btn btn primary-btn" [disabled]="walletAddressForm.invalid" translate>confirm</button>
        </form>
        <!-- CONFIRMATION SCREEN -->
        <ng-template #confirmWithdrawal>
            <div class="selected-nfts">
                <div class="nft-card p-2" *ngFor="let nft of selectedNFTs">
                    <img [src]="nft.img" alt="" srcset="" class="nft-img">
                    <div class="nft-info d-flex flex-column justify-content-between">
                        <div class="nft-details gap-sm-1 gap-1 d-flex flex-column">
                            <span class="detail-title" translate>NFT_name</span>
                            <span class="detail-value ellipsis"
                                [tooltip]="((nft.title ?? '').length > 47)  ? nft.title : ''">{{nft.title}}</span>
                        </div>
                        <div class="nft-details gap-sm-1 gap-1 d-flex flex-column">
                            <span class="detail-title" translate>token_id</span>
                            <span class="detail-value ellipsis"
                                [tooltip]="(nft.id && (nft.id.toString()).length > 47)  ? nft.id.toString() : ''">{{nft.id}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="destination-wallet d-flex flex-column gap-sm-1 gap-1">
                <span class="destination-wallet-title" translate>destination_wallet</span>
                <input type="text" [formControl]="destinationWallet" readonly>
                <img src="assets/images/svg-icons/edit-black.svg" alt="edit-icon" (click)="editAddress()" srcset=""
                    class="edit-icon">
            </div>
            <button class="action-btn btn primary-btn" [disabled]="destinationWallet.invalid || isWithdrawing" (click)="confirmWithdraw()"
                translate>confirm_withdrawal</button>
        </ng-template>
    </ng-container>
    <!-- CONTENT AFTER API CALLED -->
    <ng-template #hasWithdrawalStatus>
        <div class="withdrawal-status-wrapper w-100 d-flex flex-column">
            <img src="assets/images/svg-icons/x-close.svg" alt="close" srcset="" class="close-img" (click)="close()">
            <!-- API RETURNS SUCCESS -->
            <div *ngIf="withdrawalStatus === 'SUCCESS'; else withdrawalError"
                class="status-container d-flex flex-column">
                <div class="status-body d-flex flex-column gap-sm-2 gap-2 align-items-center">
                    <img src="assets/images/svg-icons/success-tick.svg" alt="close" srcset="" class="status-body-img">
                    <span class="status-body-text">Congrats!</span>
                </div>
                <span class="status-description">You have successfully withdrawn your NFT. Sit tight for now, we’re
                    transferring your NFT to the
                    wallet. It may take up
                    to 3 days.</span>
            </div>
            <!-- API RETURNS ERROR -->
            <ng-template #withdrawalError>
                <div class="error-status-body d-flex flex-column gap-sm-4 gap-4 align-items-center">
                    <span class="error-status-body-title">Sorry, something went wrong!</span>
                    <img src="assets/images/error-man.png" alt="" class="error-status-img">
                    <span class="error-status-msg-title">Please go back and try again.</span>
                    <span class="error-status-msg-info">It seems like you encountered an error while trying to withdraw
                        your NFT. Please go back and
                        try again.</span>
                </div>
            </ng-template>
        </div>
        <button type="submit" class="action-btn btn primary-btn" translate (click)="close()">okay</button>
    </ng-template>
</div>